// extracted by mini-css-extract-plugin
export default {"userTable":"TeamMemberList-module__userTable--ihYjW"};